import axios, { AxiosResponse } from 'axios'
import { createAsyncThunk } from '@reduxjs/toolkit'

import { ESignType } from 'Definitions/ESignType.ts'

import { ADMIN_API_URL } from 'Constants/Global.admin.constants.ts'

import { getAxiosBlobConfig, getAxiosConfig } from 'Utils/auth.util.ts'
import { handleError } from 'Helpers/errors.helper.ts'

export const signDocument = createAsyncThunk('admin/signDocument', async (purchaseId: string) => {
  const url = ADMIN_API_URL.E_SIGN.ROOT

  try {
    const { data }: AxiosResponse<{ data: ESignType }> = await axios.post(url, { purchaseId }, getAxiosConfig())
    return {
      signRequest: data.data,
    }
  } catch (error) {
    handleError(error, true)
    throw error
  }
})

export const getSignDocument = async (signRequestId: string) => {
  const url = `${ADMIN_API_URL.E_SIGN.ROOT}/${signRequestId}`

  try {
    const data: AxiosResponse = await axios.get(url, getAxiosBlobConfig())
    return data
  } catch (error) {
    handleError(error, true)
    throw error
  }
}

export const sendSignReminder = async (signRequestId: string) => {
  const url = `${ADMIN_API_URL.E_SIGN.ROOT}/${signRequestId}/send-reminder`

  try {
    const { data }: AxiosResponse<{ data: ESignType }> = await axios.post(url, {}, getAxiosConfig())
    return {
      sent: data.data,
    }
  } catch (error) {
    handleError(error, true)
    throw error
  }
}
